var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg8(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_59_5587)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.3591 17.2718V15.6677C14.3591 14.8169 14.0211 14.0009 13.4195 13.3992C12.8179 12.7976 12.0019 12.4596 11.151 12.4596H4.73474C3.88389 12.4596 3.06789 12.7976 2.46625 13.3992C1.86461 14.0009 1.52661 14.8169 1.52661 15.6677V17.2718",
    stroke: "black",
    strokeWidth: 1.80457,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.94208 9.25147C9.71388 9.25147 11.1502 7.81514 11.1502 6.04334C11.1502 4.27154 9.71388 2.83521 7.94208 2.83521C6.17028 2.83521 4.73395 4.27154 4.73395 6.04334C4.73395 7.81514 6.17028 9.25147 7.94208 9.25147Z",
    stroke: "black",
    strokeWidth: 1.80457,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1706 17.2721V15.668C19.17 14.9572 18.9334 14.2667 18.498 13.7049C18.0625 13.1431 17.4527 12.7419 16.7645 12.5642",
    stroke: "black",
    strokeWidth: 1.80457,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5571 2.93976C14.2472 3.11645 14.8589 3.51778 15.2956 4.0805C15.7324 4.64321 15.9695 5.3353 15.9695 6.04764C15.9695 6.75998 15.7324 7.45206 15.2956 8.01478C14.8589 8.57749 14.2472 8.97883 13.5571 9.15552",
    stroke: "black",
    strokeWidth: 1.80457,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_59_5587"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.2488,
    height: 19.2488,
    fill: "white",
    transform: "translate(0.724182 0.429108)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg8);
export default __webpack_public_path__ + "static/media/8.c58ccd4fdf21e6007481fe57bd9ad1d9.svg";
export { ForwardRef as ReactComponent };